import Styles from  './styles.js';
import Link from 'next/link';
import React from 'react';

const VideoDeepReview = ({ bg, title, details, btnLink }) => {
  return (
    <>
      {bg == 'white' ? (
        <div className="pt-5 ">
          <div className="lg:container mx-auto pb-3 md:pb-4">
            <div className="grid lg:grid-cols-2 gap-x-4 2xl:gap-4 py-3">
              <div className=" 2xl:px-4 md:px-4 px-6">
                <div className="lg:pl-3 px-0 md:px-0 lg:pr-1">
                  <iframe
                    width="100%"
                    height="417"
                    src="https://www.youtube.com/embed/co7TdRsbIn0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>
                </div>
              </div>

              <div className="pt-4 px-6 lg:px-0 md:pt-5 lg:pt-5 lg:pl-4">
                <h1
                  className="res-fs-size font-normal  lg:pr-1 color lg:pt-5 xl:mt-1 pt-4"
                  style={{ fontFamily: 'Fjalla One', color: '#1b1b1b' }}>
                  {title}
                </h1>

                <p
                  className="responsiveText mt-4 xl:pt-1 pb-2 xl:pr-1  "
                  style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e' }}>
                  {details}
                </p>
                <Link href={`#${btnLink}`}>
                  <button
                    type="button"
                    className="btn btn-stays font-semibold leading-[36px] text-base rounded-0 mt-4"
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      padding: '12px 28px',
                    }}>
                    See available accommodation options
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="pt-5 " style={{ backgroundColor: '#161616' }}>
          <div className="lg:container   mx-auto pb-3 pb-md-4">
            <div className="grid lg:grid-cols-2 gap-x-5 2xl:gap-x-4 py-3">
              <div className=" 2xl:px-4 lg:px-4 px-6">
                <div className="lg:pl-3 px-0 md:px-0 lg:pr-1">
                  <iframe
                    width="100%"
                    height="417"
                    src="https://www.youtube.com/embed/co7TdRsbIn0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>
                </div>
              </div>

              <div className=" pt-4 md:pt-5 px-6 lg:px-0 lg:pt-5 lg:pl-4">
                <h1
                  className="text-[44px] leading-[55px] font-normal-400  lg:pr-1 color xl:pt-4 xl:mt-1 pt-4"
                  style={{ fontFamily: 'Fjalla One', color: '#F7F7F7' }}>
                  FURNISHED LONG-TERM RENTALS AT SOULROOMS.
                </h1>

                <p
                  className="  text-[22px] leading-[33px] font-normal mt-4 pt-xl-1 pb-2 pe-xl-1  "
                  style={{ fontFamily: 'Josefin Sans', color: '#A4A4A4' }}>
                  Select from a range of furnished properties offered by amazing landlords from across the city.
                </p>
                <Link href={btnLink ? btnLink : 'find-a-soulroom'}>
                  <button
                    type="button"
                    className="btn btn-stays font-semiblod text-base rounded-0 mt-4"
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      padding: '12px 28px',
                    }}>
                    Find Properties
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
      <Styles />
    </>
  );
};

export default VideoDeepReview;
